<div [class]="theme$ | async">
  <ecp-portal>
    <router-outlet></router-outlet>
  </ecp-portal>
</div>

@if (isAuthenticated) {
<div ecpDynamicChatScript>
  <div></div>
</div>
}
